import React, { FC } from 'react'
import { AnalyticsEventsMap } from '@moonpig/launchpad-analytics'
import { styled } from '@moonpig/launchpad-utils'
import { Box, PrimaryButton } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { useFindLocaleText } from '../../../../text-localisation'

const StyledViewResultsButton = styled(PrimaryButton)<{ compact?: boolean }>`
  ${({ compact }) => `max-height: ${compact ? '48px' : '52px'};`}
  width: 100%;
`

const StyledResultsCtaWrapper = styled(Box)<{ compact?: boolean }>`
  ${({ compact }) =>
    s({
      position: 'sticky',
      bottom: 0,
      left: 0,
      p: compact ? 4 : 6,
      width: '100%',
      bgcolor: 'colorBackground01',
    })}
`

type Props = {
  onClick: () => void
  events?: AnalyticsEventsMap<HTMLButtonElement>
  loading: boolean
  resultsCount: number
  label?: string
  disabled?: boolean
  compact?: boolean
}

export const ResultsButton: FC<Props> = ({
  onClick,
  events,
  loading,
  resultsCount,
  label,
  disabled,
  compact,
}) => {
  const localiseText = useFindLocaleText()

  return (
    <StyledResultsCtaWrapper compact={compact}>
      <StyledViewResultsButton
        onClick={onClick}
        events={events}
        loading={loading}
        disabled={disabled}
        compact={compact}
      >
        <span>
          {label || localiseText('find.view_n_results', { resultsCount })}
        </span>
      </StyledViewResultsButton>
    </StyledResultsCtaWrapper>
  )
}
